import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';


import Connexion from './component/Connexion/connexion.js';
import Accueil from './component/visiteur/Accueil.js';
import Navigation from './component/navigation/navigationVisiteur.js';
import Footer from './component/visiteur/footer.js';
import Contact from './component/visiteur/contact.js';
import EquipeVisiteur from './component/visiteur/equipe.js';

import Inscription2 from './component/inscription/choixInscription.js';
import InscriptionArbitre from './component/inscription/inscriptionArbitre.js';
import InscriptionEquipe from './component/inscription/inscriptionEquipe.js';
import InscriptionJoueur from './component/inscription/inscriptionJoueur.js';
import Verification from './component/inscription/verification.js';
import ModifMdp from './component/Connexion/modifMDP.js';

import AccueilCoach from './component/Accueil_user/accueilCoach.js';
import AccueilArbitre from './component/Accueil_user/accueilArbitre.js';
import AccueilJoueur from './component/Accueil_user/accueilJoueur.js';
import Admin from './component/Admin/accèsAdmin.js';
import CotisationCoach from './component/Accueil_user/cotisation/cotisationCoach.js';
import CotisationJoueur from './component/Accueil_user/cotisation/cotisationJoueur.js';

import MessagerieCoach from './component/messagerie_user/messagerieCoach.js';
import MessagerieJoueur from './component/messagerie_user/messagerieJoueur.js';
import MessagerieArbitre from './component/messagerie_user/messagerieArbitre.js';

import AgendaCoach from './component/agenda_equipe/agendaCoach.js';
import AgendaJoueur from './component/agenda_equipe/agendaJoueur.js';
import AgendaArbitre from './component/agenda_arbitre/agendaArbitre.js';

import PostCoach from './component/post_user/postCoach.js';
import PostJoueur from './component/post_user/postJoueur.js';
import PostArbitre from './component/post_user/postArbitre.js';

import EquipeCoach from './component/equipe_user/equipeCoach.js';
import EquipeJoueur from './component/equipe_user/equipeJoueur.js';
import EquipeInfoCoach from './component/equipe_user/informationEquipeCoach.js';
import EquipeInfoJoueur from './component/equipe_user/informationEquipeJoueur.js';
import EquipeArbitre from './component/tableau-de-bord-arbitre/equipe/equipeArbitre.js';
import EquipeInfoArbitre from './component/tableau-de-bord-arbitre/equipe/equipeInfoArbitre.js';
import EquipeDetailsArbitre from './component/tableau-de-bord-arbitre/equipe/equipeDetailsArbitre.js';

import ParametreCoach from './component/parametre_user/parametreCoach.js';
import ParametreJoueur from './component/parametre_user/parametreJoueur.js';
import ParametreArbitre from './component/parametre_user/parametreArbitre.js';

import TableauDeBordJoueur from './component/tableau_de_bord_user/TableauDeBordJoueur.js';
import TableauDeBordCoach from './component/tableau_de_bord_user/TableauDeBordCoach.js';
import TableauDeBordArbitre from './component/tableau-de-bord-arbitre/TableauDeBordArbitre.js';
import ClassementJoueur from './component/tableau_de_bord_user/classement/classementJoueur.js';
import ClassementCoach from './component/tableau_de_bord_user/classement/classementCoach.js';
import ClassementArbitre from './component/tableau-de-bord-arbitre/classement/classementArbitre.js';
import ClassementAffichageArbitre from './component/tableau-de-bord-arbitre/classement/classementAffichageArbitre.js';
import MatchJoueur from './component/tableau_de_bord_user/match/matchJoueur.js';
import MatchCoach from './component/tableau_de_bord_user/match/matchCoach.js';
import MatchArbitre from './component/tableau-de-bord-arbitre/match/matchArbitre.js';
import MatchEquipeArbitre from './component/tableau-de-bord-arbitre/match/matchEquipeArbitre.js';
import SelectionCoach from './component/tableau_de_bord_user/sélection/selectionCoach.js';
import SelectionJoueur from './component/tableau_de_bord_user/sélection/selectionJoueur.js';
import SelectionGestionCoach from './component/tableau_de_bord_user/sélection/selectionGestionCoach.js';
import SelectionDetailsJoueur from './component/tableau_de_bord_user/sélection/selectionDetailsJoueur.js';
import SelectionAncienCoach from './component/tableau_de_bord_user/sélection/selectionAncienCoach.js';
import SelectionAncienJoueur from './component/tableau_de_bord_user/sélection/selectionAncienJoueur.js';
import TournoisCoach from './component/tableau_de_bord_user/tournoi/tournoisCoach.js';
import TournoiJoueur from './component/tableau_de_bord_user/tournoi/tournoisJoueur.js';
import Arbitrage from './component/tableau-de-bord-arbitre/arbitrage/arbitrage.js';
import DetailsArbitrage from './component/tableau-de-bord-arbitre/arbitrage/detailsArbitrage.js';
import ArbitrageCoach from './component/tableau_de_bord_user/arbitrage/arbitrageCoach.js';



function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<><Navigation /><Accueil /><Footer /></>} />
        <Route path="/connexion" element={<><Navigation /><div id="insc4"><Connexion /></div><Footer /></>} />
        <Route path="/equipe" element={<><Navigation /><div id="equipeVisiteur"><EquipeVisiteur /></div><Footer /></>} />
        <Route path="/reset-mdp/:token" element={<><Navigation /><div id="insc4"><ModifMdp /></div><Footer /></>} />
        <Route path="/inscription" element={<><Navigation /><div id="insc_body"><Inscription2 /></div><Footer /></>} />
        <Route path="/contact" element={<><Navigation /><div id="contact"><Contact /></div><Footer /></>} />
        <Route path="/inscription/arbitre" element={<><Navigation /><div id="insc"><InscriptionArbitre /></div><Footer /></>} />
        <Route path="/inscription/equipe" element={<><Navigation /><div id="insc2"><InscriptionEquipe /></div><Footer /></>} />
        <Route path="/inscription/joueur/:uuid" element={<><Navigation /><div id="insc3"><InscriptionJoueur /></div><Footer /></>} />
        <Route path="/verification/:uuid" element={<><Navigation /><Verification /></>} />

        <Route path="/coach/accueil" element={<AccueilCoach />} />
        <Route path="/joueurs/accueil" element={<AccueilJoueur />} />
        <Route path="/arbitre/accueil" element={<AccueilArbitre />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/coach/accueil/cotisation" element={<CotisationCoach />} />
        <Route path="/joueurs/accueil/cotisation" element={<CotisationJoueur />} />

        <Route path="/coach/messagerie" element={<MessagerieCoach />} />
        <Route path="/joueurs/messagerie" element={<MessagerieJoueur />} />
        <Route path="/arbitre/messagerie" element={<MessagerieArbitre />} />

        <Route path="/coach/agenda" element={<AgendaCoach />} />
        <Route path="/joueurs/agenda" element={<AgendaJoueur />} />
        <Route path="/arbitre/agenda" element={<AgendaArbitre />} />

        <Route path="/coach/post" element={<PostCoach />} />
        <Route path="/joueurs/post" element={<PostJoueur />} />
        <Route path="/arbitre/post" element={<PostArbitre />} />

        <Route path="/coach/equipe/:idEquipe" element={<EquipeCoach />} />
        <Route path="/joueurs/equipe/:idEquipe" element={<EquipeJoueur />} />
        <Route path="/coach/equipe/:type/:id" element={<EquipeInfoCoach />} />
        <Route path="/joueurs/equipe/:type/:id" element={<EquipeInfoJoueur />} />
        <Route path="/arbitre/tableau-de-bord/equipe/:idEquipe" element={<EquipeInfoArbitre />} />
        <Route path="/arbitre/tableau-de-bord/equipe/:type/:id" element={<EquipeDetailsArbitre />} />
        <Route path="/arbitre/tableau-de-bord/equipe" element={<EquipeArbitre />} />

        <Route path="/coach/parametre" element={<ParametreCoach />} />
        <Route path="/joueurs/parametre" element={<ParametreJoueur />} />
        <Route path="/arbitre/parametre" element={<ParametreArbitre />} />

        <Route path="/joueurs/tableau-de-bord" element={<TableauDeBordJoueur />} />
        <Route path="/coach/tableau-de-bord" element={<TableauDeBordCoach />} />
        <Route path="/arbitre/tableau-de-bord" element={<TableauDeBordArbitre />} />

        <Route path="/joueurs/tableau-de-bord/classement" element={<ClassementJoueur />} />
        <Route path="/coach/tableau-de-bord/classement" element={<ClassementCoach />} />
        <Route path="/arbitre/tableau-de-bord/classement" element={<ClassementArbitre />} />
        <Route path="/arbitre/tableau-de-bord/classement/:nomEquipe/:idEquipe" element={<ClassementAffichageArbitre />} />

        <Route path="/joueurs/tableau-de-bord/match" element={<MatchJoueur />} />
        <Route path="/coach/tableau-de-bord/match" element={<MatchCoach />} />
        <Route path="/arbitre/tableau-de-bord/match" element={<MatchArbitre />} />
        <Route path="/arbitre/tableau-de-bord/match/:nomEquipe/:idEquipe" element={<MatchEquipeArbitre />} />

        <Route path="/coach/tableau-de-bord/selection" element={<SelectionCoach />} />
        <Route path="/joueurs/tableau-de-bord/selection" element={<SelectionJoueur />} />
        <Route path="/coach/tableau-de-bord/selection/details/:idMatch" element={<SelectionGestionCoach />} />
        <Route path="/joueurs/tableau-de-bord/selection/details/:idMatch" element={<SelectionDetailsJoueur />} />
        <Route path="/coach/tableau-de-bord/selection/historique/details/:idMatch" element={<SelectionAncienCoach />} />
        <Route path="/joueurs/tableau-de-bord/selection/historique/details/:idMatch" element={<SelectionAncienJoueur />} />

        <Route path="/joueurs/tableau-de-bord/tournois" element={<TournoiJoueur />} />
        <Route path="/coach/tableau-de-bord/tournois" element={<TournoisCoach />} />

        <Route path="/coach/tableau-de-bord/arbitrage" element={<ArbitrageCoach />} />
        <Route path="/arbitre/tableau-de-bord/arbitrage" element={<Arbitrage />} />
        <Route path="/arbitre/tableau-de-bord/arbitrage/:nomEquipe/:idEquipe" element={<DetailsArbitrage />} />

        <Route path="*" element={<><Navigation /><div id="alert-message" className="alert5"><strong>ERROR 404 !</strong> Cette page n'existe pas ! <span id="alert-text"></span></div></>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
